<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formTipoProducto" :v-model="true" lazy-validation>
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Tipo de producto *"
                v-model="tipoProducto.descripcion"
                placeholder="Descripción tipo producto como SACO, CORBATA, ACCESORIOS"
                hint="Descripción tipo producto como SACO, CORBATA, ACCESORIOS"
                :rules="[
                  () => !!tipoProducto.descripcion || 'El campo es requerido',
                ]"
                :counter="60"
                required
              ></v-text-field>
            </v-flex>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveTipoProducto"
          >Guardar</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >Tipo producto guardado con éxito</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
import productoService from "@/services/tipoProductoService";

export default {
  props: {
    tipoProducto: {
      type: Object,
    },
  },
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    saveTipoProducto() {
      let self = this;

      if (self.$refs.formTipoProducto.validate()) {
        self.operationStart();

        if (self.tipoProducto.tipoProductoId === 0) {
          self.addTipoProducto();
        } else {
          self.updateTipoProducto();
        }
      }
    },
    addTipoProducto() {
      let self = this;

      productoService
        .add(self.tipoProducto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onTipoProductoAdded", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateTipoProducto() {
      let self = this;

      productoService
        .update(self.tipoProducto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onTipoProductoUpdated", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.$refs.formTipoProducto.resetValidation();
      self.tipoProducto.tipoProductoId = 0;
      self.tipoProducto.descripcion = "";
    },
  },
};
</script>
